import { useEffect, lazy, Suspense, useState } from 'react'
import { Routes, Route, useLocation, useSearchParams, Link } from 'react-router-dom'
import { Box, styled } from '@mui/material'
import { useAppDispatch } from 'state/hooks'
import { initPublicKey, setMessageInfo, setProfileInfo, setUserAssets } from 'state/user/actions'
// import { socketInit, useSocket } from 'hooks/useSocket'
import { usePrice } from 'services/module/application'
import KeepAlive from 'react-activation'
import { setUIMode } from 'state/application/reducer'
import { rewardConfigThunk, tokenListThunk, networkListThunk } from 'state/application/actions'
// import { useUser } from 'state/user/hooks'

import Home from 'pages/Home'
import Bigdata from 'services/bigdata'
import { useIsMobile } from 'hooks/useIsMobile'

const ResetPassword = lazy(() => import('pages/AccountCenter/ResetPassword'))
const RegisterSuccess = lazy(() => import('pages/AccountCenter/SignUp/RegisterSuccess'))

const MyNft = lazy(() => import('pages/MyNft'))
const Nft = lazy(() => import('pages/Nft'))
const NftDetail = lazy(() => import('pages/Nft/detail'))
const NftNewDetail = lazy(() => import('pages/NftDetail'))

const NftMintMidgardSaga = lazy(() => import('pages/Nft/mint/MidgardSaga'))
const NftMintMidgardSagaBuy = lazy(() => import('pages/Nft/mint/MidgardSaga/buy'))

const Article = lazy(() => import('pages/Article'))
const Mint = lazy(() => import('pages/Mint'))
const ArticlePreview = lazy(() => import('pages/Editor/Preview'))
const DraftList = lazy(() => import('pages/Editor/DraftList'))
const Editor = lazy(() => import('pages/Editor'))

const GameInfo = lazy(() => import('pages/Game/Info'))
const GamePublicityMidgardSaga = lazy(() => import('pages/GamePublicity/MidgardSaga'))
const GamePublicityOathofPeak = lazy(() => import('pages/GamePublicity/OathofPeak'))
const OathofPeakChapterActivity = lazy(() => import('pages/GamePublicity/OathofPeak/components/Chapter'))
const GamePublicityOldBringNew = lazy(() => import('pages/GamePublicity/OldBringNew'))
const GamePublicityOldBringNewLanPage = lazy(() => import('pages/GamePublicity/OldBringNew/landPage'))
const OtherUsers = lazy(() => import('pages/OtherUsers'))
const InvalidLink = lazy(() => import('pages/InvalidLink'))
const UserCenter = lazy(() => import('pages/UserCenter'))
const MyWallet = lazy(() => import('pages/MyWallet'))

const Setting = lazy(() => import('pages/Setting'))
const Account = lazy(() => import('pages/Setting/account'))
const Connections = lazy(() => import('pages/Setting/connections'))
const Notification = lazy(() => import('pages/Setting/notification'))
const BindPending = lazy(() => import('pages/Setting/components/BindPending'))
const NftManagePriceAlert = lazy(() => import('pages/Setting/managePriceAlert'))

const Profile = lazy(() => import('pages/Profile'))

const Reward = lazy(() => import('pages/Reward'))
const Login = lazy(() => import('pages/Login'))
const Landing = lazy(() => import('pages/Landing'))

const ThirdLoginPending = lazy(() => import('pages/AccountCenter/ThirdPartyLogin/ThirdLoginPending'))

const Protocol = lazy(() => import('pages/Protocol'))
const PrivacyPolicy = lazy(() => import('pages/Links/PrivacyPolicy'))
const CommunityGuidelines = lazy(() => import('pages/Links/CommunityGuidelines'))
const Terms = lazy(() => import('pages/Links/Terms'))
const Channel = lazy(() => import('pages/Channel'))
const Message = lazy(() => import('pages/Message'))
const Tags = lazy(() => import('pages/Tags'))

const Community = lazy(() => import('pages/Community'))
const SocialAccountLink = lazy(() => import('pages/SocialAccountLink'))
const BuyCrypto = lazy(() => import('pages/BuyCrypto'))
const LayoutBox = styled(Box)`
  min-height: calc(100vh - 257px - 116px);
  padding-top: 116px;
  &.no-padding {
    overflow: hidden;
    padding-top: 0 !important;
  }
  @media (max-width: 900px) {
    padding-top: 116px;
  }
`

const uChain: any[] = []

export default function CustomizeRoutes() {
  const dispatch = useAppDispatch()
  // const user = useUser()
  const location = useLocation()
  const [searchParams] = useSearchParams()

  const isMobile = useIsMobile()
  const [query] = useState(searchParams.get('source'))
  if (typeof query === 'string') {
    window.sessionStorage.setItem('source', query)
  }
  usePrice()
  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) {
      // socketInit(dispatch)
      dispatch(setUserAssets())
      dispatch(setProfileInfo())
      dispatch(setMessageInfo())
    } else {
      sessionStorage.removeItem('user')
    }
    dispatch(initPublicKey())
    dispatch(tokenListThunk())
    dispatch(rewardConfigThunk())
    dispatch(networkListThunk())
  }, [dispatch])

  useEffect(() => {
    uChain.push(location.pathname)
    let lastRoute = ''
    if (uChain.length > 1) {
      lastRoute = uChain[uChain.length - 2]
    }
    new Bigdata()
      .c('log')
      .s('user')
      .a('visit')
      .t(location.pathname)
      .uid('')
      .position(location.pathname)
      .referer(lastRoute)
      .ext({ uChain })
      .log()
  }, [dispatch, location, searchParams])

  useEffect(() => {
    if (
      location.pathname === '/' ||
      location.pathname.substring(0, 6) === '/game/' ||
      location.pathname.substring(0, 8) === '/article'
    ) {
      dispatch(setUIMode('light'))
    } else {
      dispatch(setUIMode('dark'))
    }
  }, [dispatch, location.pathname])

  useEffect(() => {
    const utmChannel = searchParams.get('utm_channel') || ''
    const utmCampaign = searchParams.get('utm_campaign') || ''
    const utmInviteCode = searchParams.get('invite_code') || searchParams.get('Invite_code') || ''
    const utmModel = searchParams.get('utm_model') || ''
    const utmModelItem = searchParams.get('utm_item') || ''

    utmChannel && window.sessionStorage.setItem('utm_channel', utmChannel)
    utmCampaign && window.sessionStorage.setItem('utm_campaign', utmCampaign)
    utmInviteCode && window.sessionStorage.setItem('utm_inviteCode', utmInviteCode)
    utmModel && window.sessionStorage.setItem('utm_model', utmModel)
    utmModelItem && window.sessionStorage.setItem('utm_item', utmModelItem)
  }, [searchParams])

  /* 
    解析 sessionStorage jumpAppUrl & url参数 isJumpApp是否为1
    为1则跳转
  */
  useEffect(() => {
    const [landingJumpApp] = searchParams.get('landingJumpApp') || ''

    const jumpAppUrl = window.sessionStorage.getItem('jumpAppUrl')

    if (landingJumpApp !== '1') {
      window.sessionStorage.removeItem('jumpAppUrl')
    }
    if (landingJumpApp === '1' && jumpAppUrl && isMobile) {
      console.log('landingJumpApp', { landingJumpApp, jumpAppUrl, isMobile })
      console.log('jumpAppUrl', decodeURIComponent(jumpAppUrl))
      window.sessionStorage.removeItem('jumpAppUrl')
      window.location.href = jumpAppUrl
    }
  }, [isMobile, searchParams])

  return (
    <LayoutBox className={location.pathname.indexOf('/login') > -1 ? 'no-padding' : ''}>
      <Suspense fallback={<></>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/nft"
            element={
              <KeepAlive key="nft">
                <Suspense fallback={<></>}>
                  <Nft />
                </Suspense>
              </KeepAlive>
            }
          />
          <Route path="/login" element={<Login />} />
          <Route path="/inbox" element={<Message />} />
          <Route path="/thirdlogin/user/:type" element={<ThirdLoginPending />} />
          <Route path="/mint/midgardsaga" element={<NftMintMidgardSaga />} />
          <Route path="/mint/midgardsaga/buy" element={<NftMintMidgardSagaBuy />} />
          <Route path="/game/midgardsaga/event" element={<GamePublicityMidgardSaga />} />
          <Route path="/game/OathofPeak/earlyaccess" element={<GamePublicityOathofPeak />} />
          <Route path="/game/OathofPeak/earlyaccess/task" element={<OathofPeakChapterActivity />} />
          <Route path="/referral" element={<GamePublicityOldBringNew />} />
          <Route path="/referral/invite" element={<GamePublicityOldBringNewLanPage />} />
          <Route path="/mint" element={<Mint />} />
          <Route path="/mynft" element={<MyNft />} />
          <Route path="/nft/:id/:type/:orderId/:btn" element={<NftNewDetail />} />
          <Route path="/nft/:id/:type" element={<NftNewDetail />} />
          <Route path="/nft/:id" element={<NftNewDetail />} />
          <Route path="/nft-detail/:id" element={<NftDetail />} />
          <Route path="/success" element={<RegisterSuccess />} />
          <Route path="/article/:id" element={<Article />} />
          <Route path="/draft" element={<DraftList />} />
          <Route path="/editor/:exclusiveAlias" element={<Editor />} />
          <Route path="/editor/:exclusiveAlias/:editorId" element={<Editor />} />
          <Route path="/editor/preview/:draftId" element={<ArticlePreview />} />
          <Route path="/game/:id" element={<GameInfo />} />
          <Route path="/channel/:id" element={<Channel />} />
          <Route path="/tags/:tagId" element={<Tags />} />
          <Route path="/community" element={<Community />} />
          <Route path="/invalidlink" element={<InvalidLink />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
          <Route path="/user/:id" element={<OtherUsers />} />
          <Route path="/u/:uid" element={<Profile />}></Route>
          <Route path="/landing" element={<Landing />}></Route>
          {localStorage.getItem('token') && (
            <>
              <Route path="/setting" element={<Setting />}>
                <Route path="account" element={<Account />} />
                <Route path="connections" element={<Connections />} />
                <Route path="Notifications" element={<Notification />} />
                <Route path="notification/mpa" element={<NftManagePriceAlert />} />
                <Route path="binding/:type" element={<BindPending />} />
              </Route>
              <Route path="/profile" element={<UserCenter type="profile" />}></Route>
              <Route path="/my-wallet/" element={<UserCenter type="wallet" />}>
                <Route path=":type" element={<UserCenter type="wallet" />} />
              </Route>
              <Route path="/wallet/" element={<MyWallet />}>
                <Route path=":type" element={<MyWallet />} />
              </Route>
              <Route path="favorite" element={<UserCenter type="favorite" />}></Route>
              <Route path="records" element={<UserCenter type="records" />}></Route>
            </>
          )}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/community-guidelines" element={<CommunityGuidelines />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NoMatch />} />
          <Route path="/protocol/:name" element={<Protocol />} />
          <Route path="/reward" element={<Reward />} />
          <Route path="/social/link/:socialType/:socialAccount" element={<SocialAccountLink />} />
          <Route path="/buy-crypto" element={<BuyCrypto />} />
        </Routes>
      </Suspense>
    </LayoutBox>
  )
}

const NoMatchLayout = styled(Box)`
  display: flex;
  align-content: center;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: calc((100vh - 257px - 56px) / 2);
  transform: translateY(-50%);
  width: 100%;
  a {
    color: #808080;
  }
`

function NoMatch() {
  return (
    <NoMatchLayout>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Go to the home page</Link>
      </p>
    </NoMatchLayout>
  )
}
